<template>
  <div id="app" class="wrapper">
    <!-- <app-header></app-header> -->
    <router-view/>
    <!-- <footer>
      <p class="copyright">Copyright © {{ currentYear }} 上海三点测绘科技有限公司</p>
    </footer> -->
  </div>
</template>

<script>
// import AppHeader from '@/components/Header'
export default {
  name: 'App',
  // components: { AppHeader }
  data () {
    return {
      currentYear: new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss">
@import '~bulma/bulma';

// footer {
//   position: fixed;
//   width: 100%;
//   bottom: 0;
// }

html, body {
  height: 100%;
}
.wrapper {
  position: relative;
  min-height: 100%;
  padding-bottom: 40px;
  box-sizing: border-box;
}
p.copyright {
  position: absolute;
  width: 100%;
  color: rgb(128, 128, 128);
  line-height: 40px;
  font-size: 0.7em;
  text-align: center;
  bottom: 0;
}
#head-section {
  background-color: #005F9E;
}
</style>



// WEBPACK FOOTER //
// src/App.vue